import { render, staticRenderFns } from "./ProductTab.vue?vue&type=template&id=2b075bf9&scoped=true&"
import script from "./ProductTab.vue?vue&type=script&lang=js&"
export * from "./ProductTab.vue?vue&type=script&lang=js&"
import style0 from "./ProductTab.vue?vue&type=style&index=0&id=2b075bf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b075bf9",
  null
  
)

export default component.exports